import { create } from "zustand";

interface SelectedWaypointState {
  tripId: string | null;
  waypointId: string | null;
  setSelectedWaypoint: (
    tripId: string | null,
    waypointId: string | null
  ) => void;
  clearSelectedWaypoint: () => void;
}

export const useSelectedWaypointStore = create<SelectedWaypointState>(
  (set) => ({
    tripId: null,
    waypointId: null,
    setSelectedWaypoint: (tripId, waypointId) => set({ tripId, waypointId }),
    clearSelectedWaypoint: () => set({ tripId: null, waypointId: null }),
  })
);
